import {
  cancelSubscription,
  fetchActiveSubscription,
  getSubscriptionPlans,
  undoCancelSubcription,
} from "../../endpoints/subscription.service";
import {
  CANCEL_SUBSCRIPTION_FAILURE,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  FETCH_ACTIVE_SUBSCRIPTION_PLAN_FAILURE,
  FETCH_ACTIVE_SUBSCRIPTION_PLAN_REQUEST,
  FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_FAILURE,
  FETCH_SUBSCRIPTION_PLANS_REQUEST,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  SET_ACTIVE_PLAN,
  SET_SELECTED_PLAN_DETAILS,
  UNDO_CANCEL_SUBSCRIPTION_FAILURE,
  UNDO_CANCEL_SUBSCRIPTION_REQUEST,
  UNDO_CANCEL_SUBSCRIPTION_SUCCESS,
} from "./action.types";

export const CancellationType = {
  IMMEDIATELY: 1,
  END: 2,
};

// Thunk to fetch subscription plans
export const fetchSubscriptionPlansThunk = () => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_SUBSCRIPTION_PLANS_REQUEST });
    try {
      const response = await getSubscriptionPlans();
      if (response.success) {
        dispatch({
          type: FETCH_SUBSCRIPTION_PLANS_SUCCESS,
          payload: {
            subscriptionPlans: response?.data[0]?.prices,
          },
        });
        return response?.data[0]?.prices;
      }
    } catch (error) {
      dispatch({
        type: FETCH_SUBSCRIPTION_PLANS_FAILURE,
        payload: error.message,
      });
    }
  };
};

// thunk to fetch active subscription plan
export const fetchActiveSubscriptionThunk = () => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_ACTIVE_SUBSCRIPTION_PLAN_REQUEST });
    try {
      const response = await fetchActiveSubscription();
      if (response.success) {
        dispatch({
          type: FETCH_ACTIVE_SUBSCRIPTION_PLAN_SUCCESS,
          payload: {
            activeSubscription: response?.data,
          },
        });
        return response?.data;
      }
    } catch (error) {
      dispatch({
        type: FETCH_ACTIVE_SUBSCRIPTION_PLAN_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const setSelectedPlanDetails = (payload) => ({
  type: SET_SELECTED_PLAN_DETAILS,
  payload,
});

export const setActivePlan = (payload) => ({
  type: SET_ACTIVE_PLAN,
  payload,
});

export const cancelSubscriptionThunk = (subscriptionId) => {
  return async (dispatch, getState) => {
    dispatch({ type: CANCEL_SUBSCRIPTION_REQUEST });
    try {
      const response = await cancelSubscription(subscriptionId);
      console.log("cancel subscription response", response);
      if (response.success) {
        dispatch({
          type: CANCEL_SUBSCRIPTION_SUCCESS,
          payload: {
            cancelSubscription: response?.data,
          },
        });
        return response?.data;
      }
    } catch (error) {
      dispatch({
        type: CANCEL_SUBSCRIPTION_FAILURE,
        payload: error.message,
      });
    }
  };
};

export const undoCancelSubscription = (subscriptionId) => {
  return async (dispatch) => {
    dispatch({ type: UNDO_CANCEL_SUBSCRIPTION_REQUEST });
    try {
      const response = await undoCancelSubcription(subscriptionId);
      console.log("undo cancel subscription response", response);
      if (response.success) {
        dispatch({
          type: UNDO_CANCEL_SUBSCRIPTION_SUCCESS,
          payload: {
            undoCancellation: response?.data,
          },
        });
      }
    } catch (error) {
      dispatch({
        type: UNDO_CANCEL_SUBSCRIPTION_FAILURE,
        payload: error.message,
      });
    }
  };
};
